export enum ReturnStatus {
    DRAFT = 'draft',
    SUBMITTED = 'submitted',
    LABEL_ISSUED = 'label_issued',
    LABEL_FAILED = 'label_failed',
    IN_TRANSIT = 'in_transit',
    RECEIVED = 'received',
    COMPLETED = 'completed',
    CANCELED = 'canceled'
}

// Mirrors ReturnStatus.cancelable in the CMS returns app
export const returnStatusCancelable: ReturnStatus[] = [
    ReturnStatus.DRAFT,
    ReturnStatus.SUBMITTED,
    ReturnStatus.LABEL_ISSUED,
    ReturnStatus.LABEL_FAILED,
    ReturnStatus.IN_TRANSIT
];

export enum ReturnReason {
    DEFECTIVE = 'defective',
    DAMAGED = 'damaged',
    WRONG_ITEM = 'wrong_item',
    NOT_AS_DESCRIBED = 'not_as_described',
    CUSTOMER_REQUEST = 'customer_request',
    OTHER = 'other'
}

export const returnReasonLabels: Record<ReturnReason, string> = {
    [ReturnReason.DEFECTIVE]: 'Defective',
    [ReturnReason.DAMAGED]: 'Arrived damaged',
    [ReturnReason.WRONG_ITEM]: 'Received wrong item',
    [ReturnReason.NOT_AS_DESCRIBED]: 'Not as described',
    [ReturnReason.CUSTOMER_REQUEST]: 'No longer needed',
    [ReturnReason.OTHER]: 'Other'
};

export interface ReturnEligibilityViolation {
    code: string;
    message: string;
}

export interface ReturnEligibilityLine {
    orderLine: string;
    qtyReturnable: number;
}

export interface ReturnEligibility {
    eligible: boolean;
    violations: ReturnEligibilityViolation[];
    returnableUntil: Nullable<string>;
    lines: ReturnEligibilityLine[];
}

export interface ReturnRequestLine {
    orderLine: string;
    qtyRequested: number;
    reason: ReturnReason | '';
    customerNote: string;
}

export interface ReturnRequest {
    uid: string;
    rmaNo: string;
    order: string;
    status: ReturnStatus;
    statusDisplay: string;
    reason: ReturnReason | '';
    customerMessage: string;
    returnCarrier: string;
    returnTrackingNo: string;
    returnLabelUrl: string;
    returnShippingCharge: Nullable<string>;
    createdAt: string;
    submittedAt: Nullable<string>;
    labelIssuedAt: Nullable<string>;
    canceledAt: Nullable<string>;
    lines: ReturnRequestLine[];
}

export interface CreateReturnRequestLine {
    orderLine: string;
    qty: number;
    reason?: ReturnReason | '';
    note?: string;
}

export interface CreateReturnRequest {
    order: string;
    reason?: ReturnReason | '';
    message?: string;
    lines: CreateReturnRequestLine[];
}
